<template>
  <div class="Word">
    <div style="height: 100vh; width: auto" v-html="poHtmlCode" />
  </div>
</template>
<script>
import {
  reqOriWordFill,
  reqReportWordFill,
  reqReportPdf,
  reqReportSealWordFill,
  getReportSealWord,
  reqTotOriWordFill,
  reqTotReportWordFill,
  reqTotProjectStageWordFill
} from '@/api/pageOffice';

export default {
  data() {
    return {
      poHtmlCode: '',
      wordType: '',
      readonly: 0,
      entrustmentId: null,
      ft: 0,
      hasCallback: false,
      isSaving: false
    };
  },
  async created() {
    const params = JSON.parse(pageofficectrl.WindowParams);
    const wordType = params.wordType; // entust:委托单 flow:流转单 oriData:原始数据 report:报告
    const token = params.token;
    const readonly = params?.openType == 'readonly' ? 1 : 0;
    const entrustmentId = params.entrustmentId;
    const ft = params?.ft ?? 0; // 0:合格 1:不合格
    const modelCode = params.modelCode || '';
    const resetAuditedTime = params?.resetAuditedTime == 1 ? 1 : null;
    const psId = params.psId;
    const qualityType = params.qualityType || '';
    const auditedTime = params?.auditedTime ?? null;
    const approvedTime = params?.approvedTime ?? null;

    this.wordType = wordType;
    this.readonly = readonly;
    this.entrustmentId = entrustmentId;
    this.ft = ft;
    this.hasCallback = params?.hasCallback == 1 ? true : false; // 是否回调父页面

    // #region ******** 送样检测 ********
    if (wordType === 'oriData') {
      // eslint-disable-next-line no-undef
      const { data } = await reqOriWordFill({ entrustmentId, readonly, token });
      this.poHtmlCode = data;
    }
    if (wordType === 'report') {
      // eslint-disable-next-line no-undef
      const { data } = await reqReportWordFill({ entrustmentId, ft, readonly, token });
      this.poHtmlCode = data;
    }
    if (wordType === 'sealReport') {
      // eslint-disable-next-line no-undef
      const { data } = await reqReportSealWordFill({ entrustmentId, ft, readonly, token });
      this.poHtmlCode = data;
    }
    if (wordType === 'verifySeal') {
      // eslint-disable-next-line no-undef
      pageofficectrl.DisableSave = true;
      const { data } = await getReportSealWord({ entrustmentId, ft, readonly, token });
      this.poHtmlCode = data;
    }
    if (wordType === 'PDF') {
      // 生成pdf
      const { data } = await reqReportPdf({ entrustmentId, ft, token });
      this.poHtmlCode = data;
      this.pdfSuccess();
    }
    // #endregion **** 送样检测 ********

    // #region ******** 现场检测 ********
    if (wordType === 'siteOridata') {
      // eslint-disable-next-line no-undef
      const { data } = await reqTotOriWordFill({
        entrustmentId,
        modelCode,
        readonly,
        token,
        resetAuditedTime,
        auditedTime
      });
      this.poHtmlCode = data;
    }
    if (wordType === 'siteReport') {
      // eslint-disable-next-line no-undef
      const { data } = await reqTotReportWordFill({ entrustmentId, ft, readonly, token, approvedTime });
      this.poHtmlCode = data;
    }
    if (wordType === 'qualityReport') {
      // eslint-disable-next-line no-undef
      const { data } = await reqTotProjectStageWordFill({ psId, readonly, token, type: qualityType, auditedTime, approvedTime });
      this.poHtmlCode = data;
    }
    // #endregion **** 现场检测 ********
  },
  methods: {
    //控件中的一些常用方法都在这里调用，比如保存，打印等等
    Save() {
      if (this.isSaving) {
        return;
      }

      if (this.wordType === 'sealReport') {
        // 盖章保存前校验
        let sealsJson = pageofficectrl.zoomseal.SealsAsJson;
        if (!sealsJson) return alert('请加盖检测专用章后保存！');
        let sealObj = JSON.parse(sealsJson);
        if (sealObj.length == 0) return alert('请加盖检测专用章后保存！');
      }

      try {
        // 设置保存状态
        this.isSaving = true;
        // eslint-disable-next-line no-undef
        const saveResult = pageofficectrl.WebSave();

        // 如果 WebSave 返回 Promise，则等待它完成
        if (saveResult && typeof saveResult.then === 'function') {
          saveResult.finally(() => {
            this.executePostSaveActions();
          });
        } else {
          // 如果是同步方法，直接执行后续操作
          this.executePostSaveActions();
        }
      } catch (error) {
        // 重置保存状态
        this.isSaving = false;
        console.log('err 打印:', err);
      }
    },
    executePostSaveActions() {
      try {
        if (this.hasCallback) {
          if (this.wordType === 'sealReport') {
            this.sealSaveCallback();
          } else {
            this.saveCallback();
          }
        } else {
          pageofficectrl.CloseWindow();
        }
      } finally {
        // 重置保存状态
        this.isSaving = false;
      }
    },
    SaveAs() {
      // eslint-disable-next-line no-undef
      pageofficectrl.ShowDialog(3);
    },
    PrintSet() {
      // eslint-disable-next-line no-undef
      pageofficectrl.ShowDialog(5);
    },
    PrintFile() {
      // eslint-disable-next-line no-undef
      pageofficectrl.ShowDialog(4);
    },
    Close() {
      window.external.close();
    },
    IsFullScreen() {
      pageofficectrl.FullScreen = !pageofficectrl.FullScreen;
    },
    // 盖章
    AddSeal() {
      pageofficectrl.zoomseal.AddSealByName('顺凯检测专用章');
    },
    // 验证签章
    VerifySeal() {
      pageofficectrl.zoomseal.VerifySeal();
    },
    OnPageOfficeCtrlInit() {
      if (this.wordType === 'sealReport') {
        pageofficectrl.AddCustomToolButton('加盖检测专用章', 'AddSeal()', 2);
      }
      if (this.wordType === 'verifySeal') {
        pageofficectrl.AddCustomToolButton('验证签章', 'VerifySeal()', 2);
      }
      if (this.readonly == 0) {
        pageofficectrl.AddCustomToolButton('另存为', 'SaveAs', 12);
      }
    },
    pdfSuccess() {
      window.CallParentFunc({
        funcName: 'pdfSuccess', //回调父页面的函数名
        paramJson: '',
        success: function () {},
        error: function (strErr) {
          if (strErr.indexOf('parentlost') > -1) {
            alert('父页面关闭或跳转刷新了，导致父页面函数没有调用成功！');
            return;
          }
        }
      });
      pageofficectrl.CloseWindow();
    },
    saveCallback() {
      window.CallParentFunc({
        funcName: 'saveReportCallback', //回调父页面的函数名
        paramJson: '',
        success: function () {},
        error: function (strErr) {
          if (strErr.indexOf('parentlost') > -1) {
            alert('父页面关闭或跳转刷新了，导致父页面函数没有调用成功！');
            return;
          }
        }
      });
      pageofficectrl.CloseWindow();
    },
    sealSaveCallback() {
      window.CallParentFunc({
        funcName: 'sealReportCallback', //回调父页面的函数名
        paramJson: `${this.entrustmentId},${this.ft}`,
        success: function () {},
        error: function (strErr) {
          if (strErr.indexOf('parentlost') > -1) {
            alert('父页面关闭或跳转刷新了，导致父页面函数没有调用成功！');
            return;
          }
        }
      });
      pageofficectrl.CloseWindow();
    }
  },
  mounted: function () {
    //将当前页面methods中定义的函数挂载到PageOffice控件，例如控件触发的事件、自定义按钮触发的函数。
    window.POPageMounted = this; //此行必须

    // 将PageOffice控件中的方法通过mounted挂载到window对象上，只有挂载后才能被vue组件识别
    window.Save = this.Save;
    window.SaveAs = this.SaveAs;
    window.PrintSet = this.PrintSet;
    window.PrintFile = this.PrintFile;
    window.Close = this.Close;
    window.IsFullScreen = this.IsFullScreen;
    window.AddSeal = this.AddSeal;
    window.VerifySeal = this.VerifySeal;
    window.OnPageOfficeCtrlInit = this.OnPageOfficeCtrlInit;
  }
};
</script>
